import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SavedShoppingCartService } from 'src/app/services/feature/savedShoppingCart/saved-shopping-cart.service';
import { RestoreSavedCartDialogComponent } from '../restore-saved-cart-dialog/restore-saved-cart-dialog.component';
import { DeleteSavedCartDialogComponent } from '../delete-saved-cart-dialog/delete-saved-cart-dialog.component';
import { KbCartService } from 'src/app/services/feature/cart/kb-cart.service';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import moment from 'moment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-save-cart-details',
  templateUrl: './save-cart-details.component.html',
  styleUrls: ['./save-cart-details.component.scss'],
  standalone: false
})
export class SaveCartDetailsComponent {
  savedCartDetails$: any;
  name: string = '';
  description: string = '';
  showNameText: boolean = false;
  showDescText: boolean = false;
  subscription = new Subscription();
  constructor(private route: ActivatedRoute, private savedShoppingCartService: SavedShoppingCartService,
    private router: Router, private dialog: MatDialog, private kbCartService: KbCartService,
    private globalMessageService: GlobalMessageService) {

  }

  ngOnInit() {
    this.getSavedCartDetails();
    this.subscription.add(this.kbCartService.saveCartMsg.subscribe(res => {
      if (res) {
        this.globalMessageService.add(
          res,
          GlobalMessageType.MSG_TYPE_INFO
        );
      }
    }));
  }
  back() {
    this.router.navigate(['saved-carts'])
  }

  restore() {
    const dialogConfig = new MatDialogConfig();
    this.subscription.add(this.savedCartDetails$.subscribe((item: any) => {
      if (item.savedCartData) {
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.panelClass = 'delete-saved-cart'
        const data = {
          name: item.savedCartData.name,
          id: item.savedCartData.code,
          positions: item.savedCartData.entries.length
        }
        dialogConfig.data = data;
        const dialogRef = this.dialog.open(RestoreSavedCartDialogComponent, dialogConfig);
        this.subscription.add(dialogRef.afterClosed().subscribe(
          data => {
            if (data) {
              this.router.navigate(['cart']);
            }
          }));
      }
    }));
  }

  deleteSavedCart(item) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'delete-saved-cart'
    const data = {
      name: item.name,
      id: item.code,
      positions: item.entries.length
    }
    dialogConfig.data = data;
    const dialogRef = this.dialog.open(DeleteSavedCartDialogComponent, dialogConfig);
    this.subscription.add(dialogRef.afterClosed().subscribe(
      data => {
        if (data.message === 'SUCCESS') {
          this.getSavedCartDetails();
        }
      }));
  }

  getSavedCartDetails() {
    this.subscription.add(this.route.params.subscribe((data: any) => {
      if (data.cartId) {
        this.savedCartDetails$ = this.savedShoppingCartService.getSavedCartDetails(data.cartId);
      }
    }))
  }
  formatDate(dateString: string, format?: string): string {
    const date = new Date(dateString);
    return moment(date).format(format.toUpperCase());
  }

  padZero(value: number): string {
    return value < 10 ? '0' + value : value.toString();
  }
  editName(name) {
    this.showNameText = true;
    this.name = name;
  }
  saveName(code, desc) {
    if (this.name) {
      this.subscription.add(this.savedShoppingCartService.updateSavedCartDetails(code, this.name, desc).subscribe(data => {
        this.getSavedCartDetails();
        this.showNameText = false;
      }));
    }
  }

  editDesc(desc) {
    this.showDescText = true;
    this.description = desc;
  }
  saveDesc(code, name) {
    if (this.description) {
      this.subscription.add(this.savedShoppingCartService.updateSavedCartDetails(code, name, this.description).subscribe(data => {
        this.getSavedCartDetails();
        this.showDescText = false;
      }));
    }
  }

  removeEntry(code, entryNbr) {
    this.subscription.add(this.savedShoppingCartService.removeEntry(code, entryNbr).subscribe(data => {
      this.getSavedCartDetails();
    }));
  }

  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}
